import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, handleAxiosError } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import { isAxiosError } from 'axios';

interface DeletePayload {
  id: number;
}

interface DeleteResponse {
  success: boolean;
}

export const deleteGoToTest = async (
  {
    id,
  }: DeletePayload): Promise<DeleteResponse> => {
  const res = await apiClient.delete<DeleteResponse>(
    `${queryKeys.goToTest}/${id}`,
  );

  if (isAxiosError(res)) {
    return handleAxiosError(res, 'Failed to delete "Go to test".');
  }


  return res.data;
};

type MutationFnType = (
  data: DeletePayload,
) => ReturnType<typeof deleteGoToTest>;

interface UseDeleteOptions {
  config?: MutationConfig<MutationFnType>;
}

export const useDeleteGoToTest = ({ config }: UseDeleteOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.goToTest],
      });

      if (config?.onSuccess) {
        await config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: deleteGoToTest,
  });
};
